export default "__VITE_ASSET__DRau5pUN__"